











import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import Handsontable, { DefaultSettings } from "handsontable";
import SwxTable from "@/components/SwxTable.vue";
import { Status } from "@/modules/simulator/store";

const { State, Action } = namespace("julho_14/simulator");

@Component({
    components: {
        SwxTable
    }
})
export default class ConcreteTemperatureTable extends Vue {
    @State("concrete_temperatures")
    public concreteTemperatures;

    @State
    public readonly status!: Status;

    @Ref()
    public readonly table!: SwxTable;

    get settings(): DefaultSettings {
        const vm = this;
        return {
            data: this.concreteTemperatures.map((concreteTemperature, i) => ({
                ...concreteTemperature,
                name: `TC-${`${i + 1}`.padStart(2, "0")}`
            })),
            columnHeaderHeight: 35,
            rowHeights: 35,
            stretchH: "all",
            colHeaders: ["Termômetro", "Temperatura (°C)"],
            fillHandle: "vertical",
            className: "htCenter htMiddle",
            readOnlyCellClassName: "htCellDisabled",
            cells(row?: number, col?: number) {
                const properties: { readOnly?: boolean } = {};
                if (col === 1) {
                    properties.readOnly = vm.status === Status.running;
                }

                return properties;
            },
            columns: [
                {
                    data: "name",
                    type: "text",
                    readOnly: true
                },
                {
                    data: "value",
                    type: "numeric",
                    allowEmpty: false,
                    allowInvalid: false,
                    className: "htRight htMiddle",
                    numericFormat: {
                        pattern: "0.00"
                    },
                    validator(value, callback) {
                        Handsontable.validators.NumericValidator(
                            value,
                            isValid => {
                                callback(isValid && value >= 0.0);
                            }
                        );
                    }
                }
            ],
            afterChange: this.afterChange
        };
    }

    @Watch("status")
    onUpdateStatus(): void {
        this.table.instance.render();
    }

    @Action
    public updateConcreteTemperatures;

    afterChange(
        // [row, prop, oldValue, newValue]
        changes: [number, string | number, any, any][],
        source: string
    ): void {
        if (source !== "loadData") {
            const instance = this.table.instance;
            const concreteTemperatures = [...instance.getSourceData()];
            const changedConcreteTemperatures = changes.map(
                change => concreteTemperatures[change[0]]
            );

            this.updateConcreteTemperatures({
                concreteTemperatures,
                changedConcreteTemperatures
            });
        }
    }
}
